import TableSearch from '@rio-cloud/rio-uikit/TableSearch';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import type { Dispatch } from 'redux';

import type { RootState } from '../../../../configuration/setup/store';
import { contractActions, getAssetSearch } from './redux/contract.redux';

interface Props {
    searchValue: string;
    onSearchChange: (searchValue: string) => void;
    disabled?: boolean;
}

const ContractsTableSearch = (props: Props) => {
    const { searchValue, onSearchChange, disabled } = props;
    const intl = useIntl();

    return (
        <TableSearch
            className='width-200'
            placeholder={intl.formatMessage({ id: 'intl-msg:marketplace.usage.summary.search.placeholder' })}
            value={searchValue}
            onChange={onSearchChange}
            disabled={disabled}
        />
    );
};

const mapStateToProps = (state: RootState) => ({
    searchValue: getAssetSearch(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    onSearchChange: (searchValue: string) => dispatch(contractActions.setAssetSearch(searchValue)),
});

export const ContractsTableSearchContainer = connect(mapStateToProps, mapDispatchToProps)(ContractsTableSearch);
